const endpoint = {
  LINKSPLUS: 'links-plus',
  TRANSACTIONS: 'transactions',
  LINKS: 'links',
  CHARGES: 'charges',
}

export default endpoint
